import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { motion } from 'framer-motion';
import { toast } from 'sonner';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await register(email, password, fullName);
      toast.success('Account created successfully!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: '#FAFAFA' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="bg-white p-12 rounded-lg border border-black/5">
          <h1
            className="text-4xl mb-4 text-center"
            style={{ fontFamily: 'Playfair Display, serif' }}
            data-testid="register-title"
          >
            Create Account
          </h1>
          <p className="text-[#888888] text-sm text-center mb-8">Join Navs Art Studio</p>

          <form onSubmit={handleSubmit} data-testid="register-form">
            <div className="mb-6">
              <label className="block text-sm uppercase tracking-widest mb-2" htmlFor="fullName">
                Full Name
              </label>
              <input
                id="fullName"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                data-testid="register-fullname-input"
                required
                className="w-full px-4 py-3 border border-[#E5E5E5] rounded-lg focus:outline-none focus:border-[#1A1A1A] transition-colors"
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm uppercase tracking-widest mb-2" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email-input"
                required
                className="w-full px-4 py-3 border border-[#E5E5E5] rounded-lg focus:outline-none focus:border-[#1A1A1A] transition-colors"
              />
            </div>

            <div className="mb-8">
              <label className="block text-sm uppercase tracking-widest mb-2" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password-input"
                required
                className="w-full px-4 py-3 border border-[#E5E5E5] rounded-lg focus:outline-none focus:border-[#1A1A1A] transition-colors"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              data-testid="register-submit-btn"
              className="w-full bg-[#1A1A1A] text-white hover:bg-[#333333] rounded-full px-8 py-4 text-sm uppercase tracking-widest transition-all duration-300 disabled:opacity-50"
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>

          <p className="text-center text-sm text-[#888888] mt-8">
            Already have an account?{' '}
            <Link to="/login" data-testid="register-login-link" className="text-[#1A1A1A] hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Register;
